import { gql } from '@apollo/client';

export const GET_PRE_RELEASE_ASSET = gql`
  query GetPreReleaseAsset($hex: String!) {
    preReleaseAsset(hex: $hex) {
      id
      name
      vin
      soldSaleAsset {
        id
        correctedLotNumber
        titleOwnerName
        titleShippingAddress1
        titleShippingAddress2
        titleCity
        titleState
        titleZip
        titleShipOwnerName
        titleShipShippingAddress1
        titleShipShippingAddress2
        titleShipCity
        titleShipState
        titleShipZip
      }
    }
  }
`;

export const UPDATE_SALE_ASSET_PRE_RELEASE = gql`
  mutation UpdateSaleAssetPreRelease(
    $hex: String!
    $titleOwnerName: String!
    $titleShippingAddress1: String!
    $titleShippingAddress2: String
    $titleCity: String!
    $titleState: String!
    $titleZip: String!
    $titleShipOwnerName: String!
    $titleShipShippingAddress1: String!
    $titleShipShippingAddress2: String
    $titleShipCity: String!
    $titleShipState: String!
    $titleShipZip: String!
  ) {
    updateSaleAssetPreRelease(
      hex: $hex
      titleOwnerName: $titleOwnerName
      titleShippingAddress1: $titleShippingAddress1
      titleShippingAddress2: $titleShippingAddress2
      titleCity: $titleCity
      titleState: $titleState
      titleZip: $titleZip
      titleShipOwnerName: $titleShipOwnerName
      titleShipShippingAddress1: $titleShipShippingAddress1
      titleShipShippingAddress2: $titleShipShippingAddress2
      titleShipCity: $titleShipCity
      titleShipState: $titleShipState
      titleShipZip: $titleShipZip
    ) {
      saleAsset {
        id
        titleOwnerName
        titleShippingAddress1
        titleShippingAddress2
        titleCity
        titleState
        titleZip
        titleShipOwnerName
        titleShipShippingAddress1
        titleShipShippingAddress2
        titleShipCity
        titleShipState
        titleShipZip
      }
      errors {
        path
        message
      }
    }
  }
`;
